"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _get = _interopRequireDefault(require("lodash/get"));
var _ConfirmOrderModal = _interopRequireDefault(require("./ConfirmOrderModal"));
var _ProductIconContainer = _interopRequireDefault(require("../common/ProductIcon/ProductIconContainer"));
var _APLabelWithText = _interopRequireDefault(require("../common/APLabelWithText"));
var _APNumberInput = _interopRequireDefault(require("../common/APNumberInput"));
var _FormItem = require("../form/FormItem");
var _NumberInput = require("../form/NumberInput");
var _resize = _interopRequireDefault(require("../../hocs/resize"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _recalculateOrderFeeHelper = require("../../helpers/recalculateOrderFeeHelper");
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _config = _interopRequireDefault(require("../../config"));
require("./StreamingCard.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var HIDE_24_HR_STATS = _config["default"].StreamingInstruments.Hide24HourStats;
var streamingCardClasses = (0, _cssClassesHelper.getBEMClasses)('streaming-card');
var TIF_GTC = 'TIF: GTC';
var TIF_FOK = 'TIF: FOK';
var TIF_IOC = 'TIF: IOC';
var TIMEINFORCE_GTC = '1';
var TIMEINFORCE_FOK = '4';
var TIMEINFORCE_IOC = '3';
var MARKET_ORDER = 'Market Order';
var LIMIT_ORDER = 'Limit Order';
var getCurrentTime = function getCurrentTime() {
  var today = new Date().toGMTString();
  var currentTimezoneSplit = today.split(' ');
  var extractTime = "".concat(currentTimezoneSplit[4], " UTC");
  return extractTime;
};
var CardTimezone = /*#__PURE__*/(0, _react.memo)(function () {
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    timezone = _useState2[0],
    setTimezone = _useState2[1];
  (0, _react.useEffect)(function () {
    var interval = setInterval(function () {
      setTimezone(getCurrentTime());
    }, 1000);
    return function () {
      clearInterval(interval);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('small-text-span')
  }, timezone);
});
CardTimezone.displayName = 'CardTimezone';
var StreamingCard = function StreamingCard(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('stream'),
    t = _useTranslation.t;
  var defaultSelection = props.defaultSelection,
    position = props.position,
    instrument = props.instrument,
    products = props.products,
    level1 = props.level1,
    selectOrderType = props.selectOrderType,
    productManifest = props.productManifest,
    AccountId = props.AccountId,
    showNotification = props.showNotification,
    clearForm = props.clearForm,
    selectedInstrumentId = props.selectedInstrumentId,
    additionalSlipage = props.additionalSlipage;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isConfirmModalOpen = _useState4[0],
    setConfirmModal = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    form = _useState6[0],
    setForm = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    metaData = _useState8[0],
    setMetaData = _useState8[1];
  var _useState9 = (0, _react.useState)({
      OrderFee: 0,
      productId: 0
    }),
    _useState10 = _slicedToArray(_useState9, 2),
    orderFee = _useState10[0],
    setOrderFee = _useState10[1];
  var dismissConfirmModal = function dismissConfirmModal() {
    setConfirmModal(false);
  };
  var fetchOrderFee = function fetchOrderFee(orderFeeData) {
    (0, _recalculateOrderFeeHelper.getOrderFee)(orderFeeData).then(function (result) {
      var data = _objectSpread(_objectSpread({}, result), {}, {
        product: products.find(function (prod) {
          return prod.ProductId === result.ProductId;
        }).Product
      });
      setOrderFee(data);
    });
  };
  var handleSubmit = function handleSubmit(form, orderFeeData, confirmationModalProps) {
    fetchOrderFee(orderFeeData);
    setConfirmModal(true);
    setForm(form);
    setMetaData(confirmationModalProps);
  };
  var currentLevel = (0, _get["default"])(level1, [instrument.InstrumentId], {});
  var getProductName = function getProductName(product) {
    var search = products.find(function (prod) {
      return prod.Product === product;
    });
    if (search) {
      return search.ProductFullName;
    } else {
      return product;
    }
  };
  var calculateSpread = function calculateSpread(bestBid, bestOffer) {
    var bBid = parseFloat(bestBid.replace(/,/g, ''));
    var bOffer = parseFloat(bestOffer.replace(/,/g, ''));
    return (0, _numberFormatter.formatNumberToLocale)(Math.abs(bBid - bOffer), (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement));
  };
  var fetchProductFileName = function fetchProductFileName(symbol) {
    return Object.keys(productManifest.manifest).indexOf(symbol) === -1 ? symbol + 'DEFAULT_ICON' : productManifest.manifest[symbol].iconFileName;
  };
  var fetchStartChars = function fetchStartChars(input) {
    var startString = '';
    var middleString = '';
    var middleIndex = input.length / 2;
    var leftIndex = input.length % 2 == 0 ? middleIndex - 2 : middleIndex - 1;
    var rightIndex = input.length % 2 == 0 ? middleIndex + 1 : middleIndex + 2;
    startString = input.substring(0, leftIndex);
    middleString = input.substring(leftIndex, rightIndex);
    if (middleString.includes('.') || middleString.includes(',')) {
      leftIndex = leftIndex - 1;
      startString = input.substring(0, leftIndex);
    }
    return startString;
  };
  var fetchMiddleChars = function fetchMiddleChars(input) {
    var middleString = '';
    var middleIndex = input.length / 2;
    var leftIndex = input.length % 2 == 0 ? middleIndex - 2 : middleIndex - 1;
    var rightIndex = input.length % 2 == 0 ? middleIndex + 1 : middleIndex + 2;
    middleString = input.substring(leftIndex, rightIndex);
    if (middleString.includes('.') || middleString.includes(',')) {
      leftIndex = leftIndex - 1;
    }
    middleString = input.substring(leftIndex, rightIndex);
    return middleString;
  };
  var fetchLastChars = function fetchLastChars(input) {
    var endString = '';
    var middleIndex = input.length / 2;
    var rightIndex = input.length % 2 == 0 ? middleIndex + 1 : middleIndex + 2;
    endString = input.substring(rightIndex, input.length);
    return endString;
  };
  var buyPrice = defaultSelection[position].newBuyPrice == '' ? (0, _numberFormatter.formatNumberToLocale)(currentLevel.BestOffer, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)) : defaultSelection[position].newBuyPrice;
  var sellPrice = defaultSelection[position].newSellPrice == '' ? (0, _numberFormatter.formatNumberToLocale)(currentLevel.BestBid, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)) : defaultSelection[position].newSellPrice;
  var limitBuyPrice = defaultSelection[position].limitBuyPrice == '' ? (0, _numberFormatter.formatNumberToLocale)(currentLevel.BestOffer, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)) : defaultSelection[position].limitBuyPrice;
  var limitSellPrice = defaultSelection[position].limitSellPrice == '' ? (0, _numberFormatter.formatNumberToLocale)(currentLevel.BestBid, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)) : defaultSelection[position].limitSellPrice;
  var maxValue = (0, _numberFormatter.formatNumberToLocale)(parseFloat((0, _numberFormatter.parseNumberToLocale)(buyPrice)) + parseFloat((0, _numberFormatter.parseNumberToLocale)(buyPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement));
  var minValue = (0, _numberFormatter.formatNumberToLocale)(parseFloat((0, _numberFormatter.parseNumberToLocale)(sellPrice)) - parseFloat((0, _numberFormatter.parseNumberToLocale)(sellPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement));
  var maxLimitValue = (0, _numberFormatter.formatNumberToLocale)(parseFloat((0, _numberFormatter.parseNumberToLocale)(limitBuyPrice)) + parseFloat((0, _numberFormatter.parseNumberToLocale)(limitBuyPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement));
  var minLimitValue = (0, _numberFormatter.formatNumberToLocale)(parseFloat((0, _numberFormatter.parseNumberToLocale)(limitSellPrice)) - parseFloat((0, _numberFormatter.parseNumberToLocale)(limitSellPrice)) * (parseFloat(defaultSelection[position].slipage) + additionalSlipage) * 0.0001, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement));
  var buildOrderForm = function buildOrderForm(orderType, currentLevel, selectedInstrument, inputPrice, selectedSide, timeInForce, limitPrice, minmaxLimitValue) {
    var price = inputPrice.replace(',', '');
    var quantity = defaultSelection[position].qty;
    var selectedInstrumentId = selectedInstrument.InstrumentId;
    var side = selectedSide;
    var stopPrice = '';
    var totalAmount = '0';
    var form = {
      fee: orderFee,
      limitPrice: limitPrice,
      orderType: orderType,
      quantity: quantity,
      selectedInstrumentId: selectedInstrumentId,
      side: side,
      stopPrice: stopPrice,
      timeInForce: timeInForce,
      totalAmount: totalAmount
    };
    var orderFeeData = {
      OMSId: currentLevel.OMSId,
      AccountId: AccountId,
      InstrumentId: selectedInstrumentId,
      Amount: defaultSelection[position].qty,
      Quantity: defaultSelection[position].qty,
      Side: side,
      Price: price,
      OrderType: orderType,
      BestBid: currentLevel.BestBid,
      BestOffer: currentLevel.BestOffer
    };
    var orderTotal = new _bignumber["default"](price).times(new _bignumber["default"](quantity));
    var confirmationModalProps = {
      marketPrice: price,
      orderTotal: (0, _numberFormatter.formatNumberToLocale)(orderTotal, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement)),
      Product1Symbol: selectedInstrument.Product1Symbol,
      Product2Symbol: selectedInstrument.Product2Symbol,
      isBuySide: selectedSide == '0' ? true : false,
      minmaxLimitValue: minmaxLimitValue
    };
    handleSubmit(form, orderFeeData, confirmationModalProps);
  };
  var placeBuyOrder = function placeBuyOrder(instrument, price, selectedPosition, minmaxValue, minmaxLimitValue) {
    var timeInForce = defaultSelection[position].orderTypeValue == TIF_GTC ? TIMEINFORCE_GTC : defaultSelection[position].orderTypeValue == TIF_IOC ? TIMEINFORCE_IOC : TIMEINFORCE_FOK;
    var orderType = defaultSelection[position].orderTypeValue == TIF_GTC ? MARKET_ORDER : LIMIT_ORDER;
    var selectedPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? price : minmaxLimitValue;
    var limitPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? price : minmaxLimitValue;
    if (defaultSelection[position].qty <= 0) {
      showNotification('Please enter valid quantity');
      return;
    }
    if (defaultSelection[position].orderTypeValue != TIF_GTC && defaultSelection[position].slipage <= 0) {
      showNotification('Please enter valid slippage');
      return;
    }
    buildOrderForm(orderType, currentLevel, instrument, selectedPrice, 0, timeInForce, selectedPosition, limitPrice, minmaxLimitValue);
  };
  var placeSellOrder = function placeSellOrder(instrument, price, selectedPosition, minmaxValue, minmaxLimitValue) {
    var timeInForce = defaultSelection[position].orderTypeValue == TIF_GTC ? TIMEINFORCE_GTC : defaultSelection[position].orderTypeValue == TIF_IOC ? TIMEINFORCE_IOC : TIMEINFORCE_FOK;
    var orderType = defaultSelection[position].orderTypeValue == TIF_GTC ? MARKET_ORDER : LIMIT_ORDER;
    var selectedPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? price : minmaxLimitValue;
    var limitPrice = defaultSelection[position].orderTypeValue == TIF_GTC ? '' : minmaxLimitValue;
    if (defaultSelection[position].qty <= 0) {
      showNotification('Please enter valid quantity');
      return;
    }
    if (defaultSelection[position].orderTypeValue != TIF_GTC && defaultSelection[position].slipage <= 0) {
      showNotification('Please enter valid slippage');
      return;
    }
    buildOrderForm(orderType, currentLevel, instrument, selectedPrice, 1, timeInForce, selectedPosition, limitPrice, minmaxLimitValue);
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(defaultSelection[position].orderTypeValue != TIF_GTC ? streamingCardClasses('expanded') : streamingCardClasses(), " container-with-shadow")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: "".concat(getProductName(instrument.Product1Symbol), " / ").concat(getProductName(instrument.Product2Symbol)),
    text: instrument.Symbol,
    customClass: streamingCardClasses(),
    classModifiers: 'header'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('product-icon')
  }, /*#__PURE__*/_react["default"].createElement(_ProductIconContainer["default"], {
    iconFileName: fetchProductFileName(instrument.Product1Symbol),
    size: 32
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: HIDE_24_HR_STATS ? 'hidden' : 'unset'
    }
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour Low'),
    text: (0, _numberFormatter.formatNumberToLocale)(currentLevel.SessionLow, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: streamingCardClasses()
  })), /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Spread'),
    text: calculateSpread(buyPrice, sellPrice),
    customClass: streamingCardClasses(),
    classModifiers: 'spread-text'
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      visibility: HIDE_24_HR_STATS ? 'hidden' : 'unset'
    }
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('24-Hour High'),
    text: (0, _numberFormatter.formatNumberToLocale)(currentLevel.SessionHigh, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    customClass: streamingCardClasses(),
    classModifiers: 'high-hour-text'
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('qty-container')
  }, /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    component: _NumberInput.SpinNumberInput,
    size: "small",
    valueAs: "string",
    placeholder: "0",
    name: "quantity-".concat(position),
    decimalPlaces: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.QuantityIncrement),
    step: instrument.QuantityIncrement,
    min: 0,
    max: Infinity
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-buy-container-for-graph')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-buy-container1')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-buy-container-graph')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-buy-container-graph-mirror')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
    },
    className: streamingCardClasses('lshapevertical-sell')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
    },
    className: streamingCardClasses('lshapehorizontal-sell')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('lshapeinside-sell')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
    },
    className: streamingCardClasses('lshapeoutside-sell')
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-buy-container2')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-buy-container-graph')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
    },
    className: streamingCardClasses('lshapevertical-buy')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
    },
    className: streamingCardClasses('lshapehorizontal-buy')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
    },
    className: streamingCardClasses('lshapeinside-buy')
  }), /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
    },
    className: streamingCardClasses('lshapeoutside-buy')
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('buy-sell-text-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('buy-sell-text-container-top')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
    },
    className: streamingCardClasses('buy-text-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('width-match-parent')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('sell-text-container-span-left')
  }, t('Sell')))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-text-container'),
    onClick: function onClick() {
      return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('width-match-parent')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('sell-text-container-span-right')
  }, t('Buy')))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('buy-sell-price-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('sell-price')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeSellOrder(instrument, sellPrice, position, minValue, minLimitValue);
    },
    className: streamingCardClasses('sell-text-span')
  }, /*#__PURE__*/_react["default"].createElement("span", null, fetchStartChars(sellPrice)), /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('magnifyNumber')
  }, fetchMiddleChars(sellPrice)), /*#__PURE__*/_react["default"].createElement("span", null, fetchLastChars(sellPrice)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('buy-price')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return placeBuyOrder(instrument, buyPrice, position, maxValue, maxLimitValue);
    },
    className: streamingCardClasses('buy-text-span')
  }, /*#__PURE__*/_react["default"].createElement("span", null, fetchStartChars(buyPrice)), /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('magnifyNumber')
  }, fetchMiddleChars(buyPrice)), /*#__PURE__*/_react["default"].createElement("span", null, fetchLastChars(buyPrice))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('timezone')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(CardTimezone, null)), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("select", {
    value: defaultSelection[position].orderTypeValue,
    onChange: function onChange(value) {
      return selectOrderType(position, value);
    },
    className: streamingCardClasses('ap-instrument-type-select')
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: TIF_GTC
  }, TIF_GTC), /*#__PURE__*/_react["default"].createElement("option", {
    value: TIF_FOK
  }, TIF_FOK), /*#__PURE__*/_react["default"].createElement("option", {
    value: TIF_IOC
  }, TIF_IOC)))), defaultSelection[position].orderTypeValue != TIF_GTC && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('slip-page-text')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('small-text-span')
  }, "Allowed slippage (bps)")), /*#__PURE__*/_react["default"].createElement(_APNumberInput["default"], {
    type: "text",
    placeholder: "10",
    name: "slipage-".concat(position),
    classModifiers: 'slippage',
    customClass: streamingCardClasses(),
    decimalPlaces: (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement),
    step: instrument.PriceIncrement
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: streamingCardClasses('min-max')
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('small-text-span')
  }, "Min: ", /*#__PURE__*/_react["default"].createElement("font", {
    className: streamingCardClasses('footer-text-span-min')
  }, minLimitValue))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: streamingCardClasses('small-text-span')
  }, "Max: ", /*#__PURE__*/_react["default"].createElement("font", {
    className: streamingCardClasses('footer-text-span-max')
  }, maxLimitValue))))), /*#__PURE__*/_react["default"].createElement(_ConfirmOrderModal["default"], {
    isConfirmModalOpen: isConfirmModalOpen,
    formData: form,
    dismissConfirmModal: dismissConfirmModal,
    orderFee: orderFee,
    metaData: metaData,
    priceIncrement: instrument.PriceIncrement,
    quantityIncrement: instrument.QuantityIncrement,
    clearForm: clearForm,
    selectedInstrumentId: selectedInstrumentId
  }));
};
var _default = exports["default"] = (0, _resize["default"])(StreamingCard);